import Connect from "../components/pages/Connect";

export default Connect;
